import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon'

export default function CircleIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
    </SvgIcon>
  )
}
